import { providers, utils } from 'ethers';

export const createEthereumProvider = (provider?: providers.ExternalProvider | string) => {
  const result = typeof provider === 'string' || !provider
    ? new providers.JsonRpcProvider(provider)
    : new providers.Web3Provider(provider, 'any');
  result.pollingInterval = 8000;
  return result;
};

// Web3 personal.sign treated hexadecimal messages as bytes rather than UTF-8 text.
export const signEthereumMessage = (
  provider: providers.JsonRpcProvider,
  account: string,
  message: string,
) => provider.getSigner(account).signMessage(
  utils.isHexString(message) ? utils.arrayify(message) : message,
);
